module.exports = __webpack_public_path__ + "img/print.25a12ea2.svg";